import { useEffect } from 'react';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { paths } from '../../RouterContainer';

/**
 * A dashboard of selected company
 */
export const DashboardPage = () => {
  const { company } = useCurrentCompany();
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs([{ path: paths.DASHBOARD, name: 'navigation.dashboard' }]);
  }, []);

  if (!company) {
    return (
      <div className="flex items-center justify-center h-full w-full">
        <h2 className="text-2xl font-bold">No company selected</h2>
      </div>
    );
  }
  return (
    <>
      <h1 className="text-3xl font-bold">{company?.name}</h1>
      <p>
        Tady bude nějaký základní přehled vybrané společnosti. Společnost se vybírá v levém menu,
        hned nahoře.
      </p>
    </>
  );
};
